"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RunAxiosRequest = void 0;
const axios_1 = __importDefault(require("axios"));
const querystring = __importStar(require("querystring"));
const form_data_1 = __importDefault(require("form-data"));
function RunAxiosRequest(config) {
    return axios_1.default(config);
}
exports.RunAxiosRequest = RunAxiosRequest;
class HTTPRequest {
    constructor(url, path) {
        this.url = '';
        this.path = '';
        this.params = {};
        this.body = {};
        this.formData = new form_data_1.default();
        this.useformData = false;
        this.formEncoded = {};
        this.headers = {};
        this.timeOut = 30000;
        this.error = false;
        this.errorMessage = '';
        this.firstErrorMessage = '';
        this.errorMessages = [];
        if (url)
            this.url = url;
        if (path)
            this.path = path;
        this.data = {};
    }
    async get() { return await this.execute('GET'); }
    async put() { return await this.execute('PUT'); }
    async post() { return await this.execute('POST'); }
    async delete() { return await this.execute('DELETE'); }
    checkErrors() {
        const data = this.data;
        if (Array.isArray(data?.errors)) {
            for (const error of data.errors) {
                if (typeof error === 'string')
                    this.errorMessages.push(error);
                else if (typeof error?.message === 'string')
                    this.errorMessages.push(error?.message);
            }
        }
        this.firstErrorMessage = this.errorMessages[0];
    }
    async execute(method) {
        if (!this.url && !this.path)
            return false;
        try {
            if (typeof this.preExecute === 'function') {
                const preexe = await this.preExecute();
                if (!preexe)
                    throw new Error('Error in pre-execution method');
            }
            if (typeof this.alternativeExecute === 'function') {
                this.response = await this.alternativeExecute(this.getConfig(method));
            }
            else {
                this.response = await axios_1.default(this.getConfig(method));
            }
            this.data = this.response?.data;
            this.statusCode = this?.response?.status;
            return true;
        }
        catch (e) {
            console.log(e);
            this.statusCode = e?.response?.status;
            this.error = String(e).includes('code 404') ? false : true;
            this.errorMessage = e;
            if (!String(e).includes('code 404')) {
                console.log('HTTP ERROR', this.url + this.path);
                console.log('HTTP ERROR', 'HEADERS', this.headers);
                try {
                    console.log('HTTP ERROR', JSON.stringify(e));
                }
                catch (error) {
                    console.log(error);
                }
                if (e.response && e.response.data) {
                    console.log('error', e.response.data);
                    try {
                        console.log('error-json', JSON.stringify(e.response.data));
                    }
                    catch (error) { }
                    this.data = e.response.data;
                }
            }
        }
        this.checkErrors();
        return false;
    }
    getConfig(method) {
        if (this.path && this.path.length > 0 && !this.path.startsWith('/')) {
            this.path = '/' + this.path;
        }
        let config = {};
        config.baseURL = this.url + this.path;
        config.timeout = this.timeOut;
        config.method = method;
        config.withCredentials = true;
        if (Object.keys(this.params).hasRows()) {
            config.params = this.params;
        }
        // if ( !this.headers['Connection'] ) {
        //     this.headers['Connection'] = "keep-alive";
        // }
        if (Object.keys(this.body).hasRows()) {
            config.data = this.body;
            this.headers['Content-Type'] = 'application/json';
        }
        else if (Object.keys(this.formEncoded).hasRows()) {
            config.data = querystring.stringify(this.formEncoded);
            this.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        }
        else if (this.useformData) {
            config.data = this.formData;
            this.headers['Content-Type'] = 'multipart/form-data;';
            if (typeof this.formData.getBoundary === 'function')
                this.headers['Content-Type'] = 'multipart/form-data; boundary=' + this.formData.getBoundary();
            else if (typeof this.formData.getHeaders === 'function')
                this.headers['Content-Type'] = 'multipart/form-data; boundary=' + this.formData.getHeaders();
            //this.headers = {
            //    ...this.headers,
            //    //...this.formData.getHeaders()
            //};
        }
        if (this.headers) {
            config.headers = this.headers;
            config.headers['x-client-version'] = process.env?.VERSION || process.env?.REACT_APP_VERSION || 'none';
            config.headers['x-client-code'] = process.env?.APP_CODE || process.env?.REACT_APP_APP_CODE || 'none';
        }
        return config;
    }
}
exports.default = HTTPRequest;
